import axios from 'axios'

const baseUrl = process.env.VUE_APP_BASE_API + '/excursion/geopoints'

const state = {
    hotels: [],
    hotelsByName: [],
}

const actions = {
    // load hotels search by partial name
    loadHotelsSearchByName({
        commit
    }, name) {
        axios
            .get(baseUrl + '/hotels_search_name/?hotel_name=' + name)
            .then(r => r.data)
            .then(hotels => {
                commit('SET_HOTELS_BY_NAME', hotels)
            })
    },

    // load all hotels from backend
    loadHotels({
        commit
    }) {
        axios
            .get(baseUrl + '/hotels/')
            .then(r => r.data)
            .then(hotels => {
                commit('SET_HOTELS', hotels)
            })
    }
}

const mutations = {
    SET_HOTELS(state, hotels) {
        state.hotels = hotels
    },
    SET_HOTELS_BY_NAME(state, hotels) {
        state.hotelsByName = hotels
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}